import { CSSObject, keyframes } from "@emotion/react";
import { fullGradientColors } from "../AiComponents.style";
const rotatePulseAnimation = keyframes`
  0% {
    transform: rotate(0deg) scale(1);  
  }
  50% {
    transform: rotate(180deg) scale(1.05);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
`;

export const loaderWrapperCss: CSSObject = {
  margin: "2em auto",
  width: "50px",
  height: "50px",
};

export const loaderCss: CSSObject = {
  "--stroke-width": "12",
  transformOrigin: "center center",
  animation: `${rotatePulseAnimation} 2s linear infinite`,
  circle: {
    strokeLinecap: "round",
    strokeDasharray: "251.2",
    strokeDashoffset: "50",
    r: "40",
    strokeWidth: "12",
    stroke: "url(#gradient)",
  },
};

export const gradientCss: CSSObject = {
  "stop:nth-of-type(1)": {
    stopColor: fullGradientColors.position0.color,
  },
  "stop:nth-of-type(2)": {
    stopColor: fullGradientColors.position25.color,
  },
  "stop:nth-of-type(3)": {
    stopColor: fullGradientColors.position50.color,
  },
  "stop:nth-of-type(4)": {
    stopColor: fullGradientColors.position100.color,
  },
};
